"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unauthorized = void 0;
var react_1 = __importDefault(require("react"));
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var Unauthorized = function (props) {
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 720 }, "\u7121\u52B9\u306A\u30E6\u30FC\u30B6\u30FC\u3067\u3059")));
};
exports.Unauthorized = Unauthorized;
